import { FormGroup, Validators } from '@angular/forms';
import { STATUS_OPTIONS } from 'src/app/components/shared/shared-constants';
import { InputType } from 'src/app/core/enums';
import {
  LocationProfile,
  LocationProfileDetails,
} from 'src/app/core/models/admin';
import {
  LocationValues,
  TotalRouteAdminControls,
  VehicleOptions,
} from '../../route-admin.enum';

const DEFAULT_TIME = '00:00';
const ADDRESS = $localize`StreetNo., Street`;
const LAT_DEFAULT = 'XX.XXXXXXXXXX';
const LONG_DEFAULT = 'XXX.XXXXXXXXX';

export const DISPLAY_CONSTS = {
  ADD_HEADER: $localize`Add Route`,
  EDIT_HEADER: $localize`Edit Route`,
  SECTION_HEADERS: {
    ROUTE_DETAILS: $localize`Route Details`,
    ADDRESS: $localize`Address`,
    BREAK: $localize`Break`,
  },
  ROUTE_DETAILS_HEADERS: {
    ROUTE: $localize`Route`,
    LBT: $localize`LBT`,
    OPTIMIZE: $localize`Optimize`,
    VEHICLE: $localize`Vehicle`,
  },
  ADDRESS_HEADERS: {
    LOCATION_START_END: $localize`Location Start/End`,
    ADDRESS_START_END: $localize`Address Start/End`,
    LATITUDE_START_END: $localize`Latitude Start/End`,
    LONGITUDE_START_END: $localize`Longitude Start/End`,
  },
  BREAK_HEADERS: {
    BREAK: $localize`Break`,
    BREAK_START: $localize`Break Start (hr)`,
    BREAK_END: $localize`Break End (hr)`,
    DURATION: $localize`Duration (min)`,
    DEL_WAIT_TIME: $localize`Delivery Wait Time (mins)`,
    PU_WAIT_TIME: $localize`Pickup Wait Time (mins)`,
  },
  ADD_ROUTE: $localize`Add Route`,
  SAVE: $localize`Save`,
};

export const FORM_CONTROL_DATA = {
  ROUTE: {
    defaultValue: '###',
    formControlName: TotalRouteAdminControls.ROUTE,
    validators: [Validators.required, Validators.minLength(3)],
    inputType: InputType.text,
  },
  LBT: {
    defaultValue: DEFAULT_TIME,
    formControlName: TotalRouteAdminControls.LBT,
    validators: [Validators.required, Validators.minLength(5)],
    inputType: InputType.text,
  },
  OPTIMIZE: {
    defaultValue: true,
    formControlName: TotalRouteAdminControls.OPTIMIZE,
    validators: [],
    inputType: InputType.select,
  },
  VEHICLE: {
    defaultValue: VehicleOptions.MINIVAN,
    formControlName: TotalRouteAdminControls.VEHICLE,
    validators: [],
    inputType: InputType.select,
  },
  LOCATION_START_END: {
    defaultValue: LocationValues.Facility,
    formControlName: TotalRouteAdminControls.LOCATION_START_END,
    validators: [],
    inputType: InputType.select,
  },
  ADDRESS_START_END: {
    defaultValue: ADDRESS,
    formControlName: TotalRouteAdminControls.ADDRESS_START_END,
    validators: [Validators.required],
    inputType: InputType.text,
  },
  LAT_START_END: {
    defaultValue: LAT_DEFAULT,
    formControlName: TotalRouteAdminControls.LAT_START_END,
    validators: [Validators.required],
    inputType: InputType.text,
  },
  LONG_START_END: {
    defaultValue: LONG_DEFAULT,
    formControlName: TotalRouteAdminControls.LONG_START_END,
    validators: [Validators.required],
    inputType: InputType.text,
  },
  BREAK: {
    defaultValue: true,
    formControlName: TotalRouteAdminControls.BREAK,
    validators: [],
    inputType: InputType.select,
  },
  BREAK_START: {
    defaultValue: '1',
    formControlName: TotalRouteAdminControls.BREAK_START,
    validators: [Validators.required, Validators.max(4)],
    inputType: InputType.text,
  },
  BREAK_END: {
    defaultValue: '2',
    formControlName: TotalRouteAdminControls.BREAK_END,
    validators: [Validators.required, Validators.max(7), Validators.min(2)],
    inputType: InputType.text,
  },
  DURATION: {
    defaultValue: '0',
    formControlName: TotalRouteAdminControls.DURATION,
    validators: [Validators.required, Validators.max(120)],
    inputType: InputType.number,
  },
  DEL_WAIT_TIME: {
    defaultValue: '1',
    formControlName: TotalRouteAdminControls.DEL_WAIT_TIME,
    validators: [Validators.required, Validators.max(10), Validators.min(1)],
    inputType: InputType.number,
  },
  PU_WAIT_TIME: {
    defaultValue: '1',
    formControlName: TotalRouteAdminControls.PU_WAIT_TIME,
    validators: [Validators.required, Validators.max(10), Validators.min(1)],
    inputType: InputType.number,
  },
};

export const DROPDOWN_VALUES = {
  imageDropdownOptions: [
    {
      label: STATUS_OPTIONS.ACTIVE,
      value: true,
    },
    {
      label: STATUS_OPTIONS.DEACTIVATED,
      value: false,
    },
  ],
  facilityDropdownOptions: [
    {
      label: LocationValues.Facility,
      value: LocationValues.Facility,
    },
    {
      label: LocationValues.Other,
      value: LocationValues.Other,
    },
  ],
  vehicleDropdownOptions: [
    {
      label: VehicleOptions.MINIVAN,
      value: VehicleOptions.MINIVAN,
    },
    {
      label: VehicleOptions.CARGO_VAN,
      value: VehicleOptions.CARGO_VAN,
    },
    {
      label: VehicleOptions.LARGE_CARGO_VAN,
      value: VehicleOptions.LARGE_CARGO_VAN,
    },
    {
      label: VehicleOptions.TRUCK,
      value: VehicleOptions.TRUCK,
    },
    {
      label: VehicleOptions.UPS,
      value: VehicleOptions.UPS,
    },
  ],
};

export type AddRouteIdoDataType = LocationProfileDetails & {
  duration?: string;
  break_exist: string;
  route_id: string;
  leavebldg_time: string;
  is_optimizeroute: string;
  vehicle: string;
  startend_location: string;
  startend_address: string;
  startend_latitude: string;
  startend_longitude: string;
  break_start: string;
  break_end: string;
  break_duration: string;
  waittime_del: string;
  waittime_pickup: string;
};

export type AddEditRoutePopupData = {
  form?: FormGroup;
  data: AddRouteIdoDataType;
  isEdit: boolean;
  location: LocationProfile;
};
